import styled from 'styled-components';

import vars from 'variables';

import background from 'assets/Common/ReadyToStart/background.png';

const Root = styled.div`
  position: relative;

  p, strong {
    color: ${vars.colors.white};
  }

  a {
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 1px solid white;
  }

  img {
    top: 0;
    right: 80px;
    width: 530px;
    position: absolute;
  }

  .contract-links {
    opacity: 0.85;
  }

  ${vars.desktop.mediaQuery} {
    & {
      margin-top: 120px;
      padding: 115px 0;
    }

    .content {
      padding: 70px 140px;
      position: relative;
      background: url(${background});
      background-size: 100% 100%;
      border-radius: 30px;
    }

    p {
      padding: 25px 0 30px;
    }

    a {
      margin-right: 25px;
    }

    a.claim {
      font-size: 0.775rem;
    }

    .lines {
      top: 0;
      left: calc(50% - 100px);
      bottom: 0;
      width: 200px;
      position: absolute;
      opacity: 0.25;
      border-left: 1px solid white;
      border-right: 1px solid white;
    }
  }

  ${vars.mobile.mediaQuery} {
    & {
      margin-bottom: 50px;
      text-align: center;
    }

    .content {
      padding: 25px;
      background-image: url(${background});
      background-position: -320px bottom;
      border-radius: 15px;
    }

    h2 {
      font-size: 1.65rem;
      letter-spacing: 0.5px;
      line-height: 130%;
    }

    p {
      padding: 5px 0 22px;
    }

    a.button {
      margin: 0 auto;
      margin-bottom: 17px;
      display: table;
    }

    br {
      display: none;
    }

    img {
      display: none;
    }
  }
`;

export { Root };
